<template>
  <div class="stability-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex><strong>公式：</strong>θ &lt; arctan(b/h)</div>
    </div>

    <div class="main-layout vertical">
      <!-- 2D 稳定域模拟 -->
      <div class="canvas-item simulation">
         <svg width="100%" height="240" viewBox="0 0 400 240">
            <!-- 地面 -->
            <line x1="0" y1="220" x2="400" y2="220" stroke="#555" stroke-width="2" />
            
            <!-- 倾斜底座 (地面倾斜) -->
            <g :transform="`rotate(${groundAngle}, 200, 220)`">
                <!-- 物体 -->
                <g transform="translate(180, 120)">
                    <rect x="-20" y="0" width="40" height="100" fill="#2c3e50" stroke="#00d2ff" stroke-width="2" />
                    <!-- 重心 G -->
                    <circle cx="0" cy="50" r="4" fill="#ff4757" />
                    <text x="8" y="55" fill="#ff4757" font-size="10">重心 G</text>
                    <!-- 重力垂线 -->
                    <line x1="0" y1="50" x2="0" y2="200" stroke="#ff4757" stroke-width="1.5" stroke-dasharray="4,2" :transform="`rotate(${-groundAngle}, 0, 50)`" />
                </g>
            </g>

            <!-- 指示器 -->
            <path v-if="isTipping" d="M 300 50 L 350 100 M 350 50 L 300 100" stroke="#ff4757" stroke-width="5" />
         </svg>

         <div class="hud-top">
            <div class="status-badge" :class="isTipping ? 'risk' : 'safe'">
               {{ isTipping ? '不稳定：即将倾覆' : '稳定状态' }}
            </div>
         </div>
      </div>

      <!-- 参数控制 -->
      <div class="bottom-controls">
         <div class="control-card glass">
            <div class="row">
               <div class="col">
                  <label>地面倾角 (θ)</label>
                  <el-slider v-model="groundAngle" :min="-45" :max="45" size="mini"></el-slider>
               </div>
               <div class="col">
                  <label>重心高度 (h)</label>
                  <el-slider v-model="cgHeight" :min="10" :max="90" size="mini"></el-slider>
               </div>
            </div>
         </div>

         <div class="stability-hint">
            <p><strong>稳定性三要素：</strong>1. 支撑面越大越稳；2. 重心越低越稳；3. 重力线必须落在支撑面以内。当重力线超出支撑面边缘，物体就会发生<strong>倾覆</strong>。</p>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StabilityViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      groundAngle: 15,
      cgHeight: 50
    }
  },
  computed: {
    isTipping() {
       // Calculation: tan(theta) > (width/2) / h
       // width = 40, width/2 = 20
       const rad = Math.abs(this.groundAngle) * Math.PI / 180;
       const limit = 20 / this.cgHeight;
       return Math.tan(rad) > limit;
    }
  }
}
</script>

<style scoped lang="scss">
.stability-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.viz-header { display: flex; justify-content: space-between; align-items: center; .title { font-size: 1rem; color: #fff; } .formula-chip { color: #ffab00; background: rgba(255,171,0,0.1); padding: 4px 12px; border-radius: 8px; font-weight: bold; } }
.canvas-item { 
   background: #0a0a0f; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05);
   .hud-top { position: absolute; top: 15px; left: 15px; 
      .status-badge { padding: 4px 12px; border-radius: 4px; font-size: 0.7rem; font-weight: bold; &.safe { color: #2ed573; background: rgba(46,213,115,0.1); } &.risk { color: #ff4757; background: rgba(255,71,87,0.1); animation: blink 1s infinite; } }
   }
}
.bottom-controls { flex: 0.5; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; .row { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; label { font-size: 0.7rem; color: #888; display: block; margin-bottom: 5px; } } }
.stability-hint { background: rgba(255, 171, 0, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
@keyframes blink { 0%, 100% { opacity: 1; } 50% { opacity: 0.5; } }
</style>
